var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/listing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/listing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0635591,2.78887695 C12.6158438,2.78887695 13.0635591,3.2365922 13.0635591,3.78887695 L13.063,9.556 L19.8819801,9.55606267 C20.0674352,9.55606267 20.2482815,9.60760862 20.4048497,9.70364771 L20.5174163,9.78390929 C20.9438648,10.134851 21.0050752,10.7650503 20.6541335,11.1914989 L12.7085943,20.8465593 C12.5186386,21.0773848 12.2353783,21.2111231 11.9364409,21.2111231 C11.3841562,21.2111231 10.9364409,20.7634078 10.9364409,20.2111231 L10.936,14.443 L4.11801989,14.4439373 C3.93256483,14.4439373 3.75171849,14.3923914 3.59515032,14.2963523 L3.48258368,14.2160907 C3.05613515,13.865149 2.99492479,13.2349497 3.34586651,12.8085011 L11.2914057,3.15344074 C11.4813614,2.92261523 11.7646217,2.78887695 12.0635591,2.78887695 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.fbc79efc934125e4d35d920e9b444a57.svg";
export { ForwardRef as ReactComponent };